import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'

type SearchContext = comluxgroup.SearchContext_1_0_3
type ContextFactoryReturn = { schema: string, data: Record<string, unknown> }

const searchContextFactory: ((data: SearchContext) => ContextFactoryReturn) = (
  (comluxgroup as Record<string, any>).createSearchContext_1_0_3 ??
  (comluxgroup as Record<string, any>).createSearchContext_1_0_2 ??
  (comluxgroup as Record<string, any>).createSearchContext_1_0_1 ??
  (comluxgroup as Record<string, any>).createSearchContext_1_0_0
)

export default function createSearchContext(data: SearchContext): ContextFactoryReturn {
  if (!searchContextFactory) {
    throw new Error('Missing Snowplow SearchContext factory')
  }

  return searchContextFactory(data)
}
